import { cfgToThemeCdnPath, FeatureSet } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const createFlushCanonicalItems = ({ removePromotionDuplicatesFromTopSectionSurface, createPromotionFromTopSection, bannersBase }) => {
    const items = [
        {
            id: 'flush-races',
            promotion: {
                id: 'flush-races',
                title: Verbiage.weekly_races,
                startDate: new Date('2025-09-01T00:00:00Z'),
                description: Verbiage.weekly_races_description,
                buttonText: Verbiage.race_now,
                url: '/promotion-page/race/flush-races/',
                banner: cfgToThemeCdnPath('/promotions/races/races.png')
            },
            surfaces: {},
            order: { promotions: 0 }
        },
        {
            id: 'jelly-express-daily-tournaments',
            promotion: {
                id: 'jelly-express-daily-tournaments',
                title: Verbiage.jelly_express_daily_tournaments,
                startDate: new Date('2026-04-06T12:00:00.000Z'),
                endDate: new Date('2026-05-03T16:59:59.999Z'),
                description: null,
                showTimezoneSuffixInFallback: false,
                buttonText: Verbiage.play_now,
                url: '/promotion-page/jelly-express-daily-tournaments/',
                action: true,
                customAction: '/p/pragmatic-play/jelly_express/',
                banner: cfgToThemeCdnPath('/promotions/jelly_express_daily_tournaments/jelly_express_daily_tournaments.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/jelly_express_daily_tournaments/jelly_express_daily_tournaments-detail.png')
            },
            surfaces: {},
            order: { promotions: 1 }
        },
        {
            id: 'daily-slot-tournaments-and-weekly-wheel-drops',
            promotion: {
                id: 'daily-slot-tournaments-and-weekly-wheel-drops',
                title: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops,
                startDate: new Date('2026-03-30T12:00:00.000Z'),
                endDate: new Date('2026-04-27T11:59:59.999Z'),
                description: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/daily-slot-tournaments-and-weekly-wheel-drops/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/daily_slot_tournaments_and_weekly_wheel_drops/daily_slot_tournaments_and_weekly_wheel_drops.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/daily_slot_tournaments_and_weekly_wheel_drops/daily_slot_tournaments_and_weekly_wheel_drops-detail.png')
            },
            surfaces: {},
            order: { promotions: 2 }
        },
        {
            id: 'champions-league-free-bet',
            promotion: {
                id: 'champions-league-free-bet',
                title: Verbiage.champions_league_free_bet,
                startDate: new Date('2026-02-11T00:00:00Z'),
                endDate: new Date('2026-05-30T23:59:59Z'),
                description: Verbiage.champions_league_free_bet_description,
                titleSingleLine: true,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/champions-league-free-bet/',
                action: true,
                customAction: '/sports/soccer-1/',
                banner: cfgToThemeCdnPath('/promotions/champions_league_free_bet/champions_league_free_bet.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/champions_league_free_bet/champions_league_free_bet-detail.png')
            },
            surfaces: {},
            order: { promotions: 3 }
        },
        {
            id: 'level-up',
            promotion: {
                id: 'level-up',
                promoType: 'reward',
                rewardType: 'LEVEL_UP',
                title: Verbiage.reward_promo_level_up_bonus_title,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.reward_promo_level_up_bonus_description,
                buttonText: Verbiage.claim_now,
                url: '/vip/',
                useUrlForDetail: true,
                conditionalUrl: {
                    loggedInUrl: '/vip-dashboard/',
                    loggedOutUrl: '/vip/'
                },
                action: true,
                banner: cfgToThemeCdnPath('/promotions/level_up/level_up.png')
            },
            surfaces: {},
            order: { promotions: 4 }
        },
        {
            id: 'rakeback',
            promotion: {
                id: 'rakeback',
                promoType: 'reward',
                rewardType: 'RAKEBACK',
                title: Verbiage.reward_promo_rakeback_title,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.reward_promo_rakeback_description,
                buttonText: Verbiage.claim_now,
                url: '/vip/',
                useUrlForDetail: true,
                conditionalUrl: {
                    loggedInUrl: '/vip-dashboard/',
                    loggedOutUrl: '/vip/'
                },
                action: true,
                banner: cfgToThemeCdnPath('/promotions/rakeback/rakeback.png')
            },
            surfaces: {},
            order: { promotions: 5 }
        },
        {
            id: 'daily-bonus',
            promotion: {
                id: 'daily-bonus',
                promoType: 'reward',
                rewardType: 'CASHBACK_DAILY',
                title: Verbiage.reward_promo_daily_bonus_title,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.reward_promo_daily_bonus_description,
                buttonText: Verbiage.claim_now,
                url: '/vip/',
                useUrlForDetail: true,
                conditionalUrl: {
                    loggedInUrl: '/vip-dashboard/',
                    loggedOutUrl: '/vip/'
                },
                action: true,
                banner: cfgToThemeCdnPath('/promotions/daily_bonus/daily_bonus.png')
            },
            surfaces: {},
            order: { promotions: 6 }
        },
        {
            id: 'referral',
            promotion: {
                id: 'referral',
                title: Verbiage.refer_and_earn_banner_title,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.refer_and_earn_banner_description,
                buttonText: Verbiage.refer_now,
                action: true,
                url: '/referral-dashboard/',
                banner: cfgToThemeCdnPath('/promotions/referral-dashboard/referral-dashboard.jpg'),
                bannerBig: cfgToThemeCdnPath('/promotions/referral-dashboard/referral-dashboard-detail.png')
            },
            surfaces: {},
            order: { promotions: 7 }
        },
        {
            id: 'weekly-bonus',
            promotion: {
                id: 'weekly-bonus',
                promoType: 'reward',
                rewardType: 'CASHBACK_WEEKLY',
                title: Verbiage.reward_promo_weekly_bonus_title,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.reward_promo_weekly_bonus_description,
                buttonText: Verbiage.claim_now,
                url: '/vip/',
                useUrlForDetail: true,
                conditionalUrl: {
                    loggedInUrl: '/vip-dashboard/',
                    loggedOutUrl: '/vip/'
                },
                action: true,
                banner: cfgToThemeCdnPath('/promotions/weekly_bonus/weekly_bonus.png')
            },
            surfaces: {},
            order: { promotions: 8 }
        },
        {
            id: 'monthly-bonus',
            promotion: {
                id: 'monthly-bonus',
                promoType: 'reward',
                rewardType: 'CASHBACK_MONTHLY',
                title: Verbiage.reward_promo_monthly_bonus_title,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.reward_promo_monthly_bonus_description,
                buttonText: Verbiage.claim_now,
                url: '/vip/',
                useUrlForDetail: true,
                conditionalUrl: {
                    loggedInUrl: '/vip-dashboard/',
                    loggedOutUrl: '/vip/'
                },
                action: true,
                banner: cfgToThemeCdnPath('/promotions/monthly_bonus/monthly_bonus.png')
            },
            surfaces: {},
            order: { promotions: 9 }
        },
        {
            id: 'advent-calendar',
            promotion: {
                id: 'advent-calendar',
                title: Verbiage.advent_calendar_banner_title,
                startDate: new Date('2025-12-1T00:00:00Z'),
                endDate: new Date('2025-12-31T23:59:59Z'),
                description: Verbiage.advent_calendar_banner_description,
                buttonText: Verbiage.play_now,
                url: '/calendar/',
                useUrlForDetail: true,
                requiresAuth: true,
                customTitleWidth: '45%',
                banner: cfgToThemeCdnPath('/promotions/advent_calendar/advent_calendar.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/advent_calendar/advent_calendar-detail.png')
            },
            surfaces: {},
            order: { promotions: 10 }
        },
        {
            id: 'rakeboost',
            promotion: {
                id: 'rakeboost',
                title: Verbiage.rakeboost,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.rakeboost_description,
                buttonText: Verbiage.play_now,
                url: '/vip/',
                useUrlForDetail: true,
                banner: cfgToThemeCdnPath('/promotions/rakeboost/rakeboost.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/rakeboost/rakeboost-detail.png')
            },
            surfaces: {},
            order: { promotions: 11 }
        },
        {
            id: 'sports',
            promotion: {
                id: 'sports',
                title: Verbiage.sports,
                startDate: new Date('2025-07-21T00:00:00Z'),
                description: Verbiage.sports_description,
                buttonText: Verbiage.play_now,
                url: '/sports/',
                rel: FeatureSet.Preview,
                banner: cfgToThemeCdnPath('/promotions/sports/sports.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/sports/sports-detail.png')
            },
            surfaces: {},
            order: { promotions: 12 }
        },
        {
            id: 'super-scatter',
            promotion: {
                id: 'super-scatter',
                title: Verbiage.super_scatter,
                startDate: new Date('2025-08-01T00:00:00Z'),
                endDate: new Date('2025-08-18T23:59:59Z'),
                description: Verbiage.super_scatter_description,
                buttonText: Verbiage.play_now,
                url: '/promotion-page/super-scatter/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/super_scatter/super_scatter.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/super_scatter/super_scatter-detail.png')
            },
            surfaces: {},
            order: { promotions: 13 }
        },
        {
            id: 'welcome-deposit-bonus',
            promotion: {
                id: 'welcome-deposit-bonus',
                title: Verbiage.welcome_offer,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.welcome_offer_description,
                buttonText: Verbiage.deposit,
                url: '/casino/',
                banner: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus-detail.png'),
                action: true
            },
            surfaces: {},
            order: { promotions: 14 }
        },
        {
            id: 'multiplier-madness',
            promotion: {
                id: 'multiplier-madness',
                title: Verbiage.multiplier_madness,
                startDate: new Date('2024-07-15T00:00:00Z'),
                description: Verbiage.multiplier_madness_description,
                buttonText: Verbiage.play_now,
                url: '/promotion-page/multiplier-madness/',
                rel: FeatureSet.Preview,
                action: true,
                banner: cfgToThemeCdnPath('/promotions/multiplier_madness/multiplier_madness.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/multiplier_madness/multiplier_madness-detail.png')
            },
            surfaces: {},
            order: { promotions: 15 }
        },
        {
            id: 'blaze-zombie',
            promotion: {
                id: 'blaze-zombie',
                title: Verbiage.blaze_zombie,
                startDate: new Date('2025-08-29T00:00:00Z'),
                endDate: new Date('2025-09-12T23:59:59Z'),
                description: Verbiage.blaze_zombie_description,
                buttonText: Verbiage.play_now,
                url: '/promotion-page/blaze-zombie/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/blaze_zombie/blaze_zombie.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/blaze_zombie/blaze_zombie-detail.png')
            },
            surfaces: {},
            order: { promotions: 16 }
        },
        {
            id: 'canelo-vs-crawford',
            promotion: {
                id: 'canelo-vs-crawford',
                title: '[CANELO VS CRAWFORD]',
                startDate: new Date('2025-09-13T01:00:00Z'),
                endDate: new Date('2025-09-14T01:00:00Z'),
                description: Verbiage.canelo_vs_crawford_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/canelo-vs-crawford/',
                action: true,
                infoAndTermsSeparated: true,
                customAction: '/sports/boxing-10/',
                banner: cfgToThemeCdnPath('/promotions/canelo_vs_crawford/canelo_vs_crawford.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/canelo_vs_crawford/canelo_vs_crawford-detail.png')
            },
            surfaces: {},
            order: { promotions: 17 }
        },
        {
            id: 'sweet-bonanza',
            promotion: {
                id: 'sweet-bonanza',
                title: Verbiage.sweet_bonanza,
                startDate: new Date('2025-09-30T13:00:00Z'),
                endDate: new Date('2025-10-14T18:00:00Z'),
                description: Verbiage.daily_tournaments,
                buttonText: Verbiage.play_now,
                url: '/promotion-page/sweet-bonanza/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/sweet_bonanza/sweet_bonanza.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/sweet_bonanza/sweet_bonanza-detail.png')
            },
            surfaces: {},
            order: { promotions: 18 }
        },
        {
            id: 'world-series-bad-beat-bailout',
            promotion: {
                id: 'world-series-bad-beat-bailout',
                title: Verbiage.world_series_bad_beat_bailout,
                startDate: new Date('2025-10-24T00:00:00Z'),
                endDate: new Date('2025-11-01T23:59:59Z'),
                description: Verbiage.world_series_bad_beat_bailout_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/world-series-bad-beat-bailout/',
                action: true,
                customAction: '/sports/baseball/usa/mlb-1671175995522211840/',
                banner: cfgToThemeCdnPath('/promotions/world_series_bad_beat_bailout/world_series_bad_beat_bailout.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/world_series_bad_beat_bailout/world_series_bad_beat_bailout-detail.png')
            },
            surfaces: {},
            order: { promotions: 19 }
        },
        {
            id: 'mnf-bet-builder-bailout',
            promotion: {
                id: 'mnf-bet-builder-bailout',
                title: Verbiage.mnf_bet_builder_bailout,
                startDate: new Date('2025-10-22T00:00:00Z'),
                endDate: new Date('2026-02-08T23:59:59Z'),
                description: Verbiage.mnf_bet_builder_bailout_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/mnf-bet-builder-bailout/',
                action: true,
                customAction: '/sports/football/usa/nfl-1669818837568196608/',
                banner: cfgToThemeCdnPath('/promotions/mnf_bet_builder_bailout/mnf_bet_builder_bailout.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/mnf_bet_builder_bailout/mnf_bet_builder_bailout-detail.png')
            },
            surfaces: {},
            order: { promotions: 20 }
        },
        {
            id: 'super-scatter-series-daily-tournaments',
            promotion: {
                id: 'super-scatter-series-daily-tournaments',
                title: Verbiage.super_scatter_series_daily_tournaments,
                startDate: new Date('2025-10-31T00:00:00Z'),
                endDate: new Date('2025-11-13T23:59:59Z'),
                description: Verbiage.super_scatter_series_daily_tournaments_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/super-scatter-series-daily-tournaments/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/super_scatter_series_daily_tournaments/super_scatter_series_daily_tournaments.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/super_scatter_series_daily_tournaments/super_scatter_series_daily_tournaments-detail.png')
            },
            surfaces: {},
            order: { promotions: 21 }
        },
        {
            id: 'daily-slot-tournaments-and-weekly-wheel-drops',
            promotion: {
                id: 'daily-slot-tournaments-and-weekly-wheel-drops',
                title: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops,
                startDate: new Date('2025-10-28T00:00:00Z'),
                endDate: new Date('2025-11-24T23:59:59Z'),
                description: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/daily-slot-tournaments-and-weekly-wheel-drops/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/daily_slot_tournaments_and_weekly_wheel_drops/daily_slot_tournaments_and_weekly_wheel_drops.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/daily_slot_tournaments_and_weekly_wheel_drops/daily_slot_tournaments_and_weekly_wheel_drops-detail.png')
            },
            surfaces: {},
            order: { promotions: 22 }
        },
        {
            id: 'daily-wins-slots',
            promotion: {
                id: 'daily-wins-slots',
                title: Verbiage.daily_wins_slots,
                startDate: new Date('2026-01-04T16:00:00Z'),
                endDate: new Date('2026-02-01T15:59:59Z'),
                description: Verbiage.daily_wins_slots_description,
                buttonText: Verbiage.play_now,
                url: '/promotion-page/daily-wins-slots/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/daily_wins_slots/daily_wins_slots.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/daily_wins_slots/daily_wins_slots-detail.png')
            },
            surfaces: {},
            order: { promotions: 23 }
        },
        {
            id: 'daily-wins-slots-11',
            promotion: {
                id: 'daily-wins-slots-11',
                title: Verbiage.daily_wins_slots,
                startDate: new Date('2026-02-02T00:00:00Z'),
                endDate: new Date('2026-03-01T23:59:59Z'),
                description: Verbiage.daily_wins_slots_description,
                buttonText: Verbiage.play_now,
                url: '/promotion-page/daily-wins-slots-11/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/daily_wins_slots/daily_wins_slots.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/daily_wins_slots/daily_wins_slots-detail.png')
            },
            surfaces: {},
            order: { promotions: 24 }
        },
        {
            id: 'super-bowl-free-bet',
            promotion: {
                id: 'super-bowl-free-bet',
                title: Verbiage.super_bowl_free_bet,
                startDate: new Date('2026-02-03T00:00:00Z'),
                endDate: new Date('2026-02-09T00:00:00Z'),
                description: Verbiage.super_bowl_free_bet_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/super-bowl-free-bet/',
                action: true,
                customAction: '/sports/american-football/usa/nfl/new-england-patriots-seattle-seahawks-2627392172848193570/',
                banner: cfgToThemeCdnPath('/promotions/super_bowl_free_bet/super_bowl_free_bet.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/super_bowl_free_bet/super_bowl_free_bet-detail.png')
            },
            surfaces: {},
            order: { promotions: 25 }
        },
        {
            id: 'daily-slot-tournaments-and-weekly-wheel-drops',
            promotion: {
                id: 'daily-slot-tournaments-and-weekly-wheel-drops',
                title: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops,
                startDate: new Date('2026-03-01T16:00:00Z'),
                endDate: new Date('2026-03-30T11:59:59Z'),
                description: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops_description,
                buttonText: Verbiage.bet_now,
                url: '/promotion-page/daily-slot-tournaments-and-weekly-wheel-drops/',
                action: true,
                banner: cfgToThemeCdnPath('/promotions/daily_slot_tournaments_and_weekly_wheel_drops/daily_slot_tournaments_and_weekly_wheel_drops.png'),
                bannerBig: cfgToThemeCdnPath('/promotions/daily_slot_tournaments_and_weekly_wheel_drops/daily_slot_tournaments_and_weekly_wheel_drops-detail.png')
            },
            surfaces: {},
            order: { promotions: 26 }
        }
    ];
    const byId = new Map(items.map((item) => [item.id, item]));
    const setTopSection = (canonicalId, topSection, order) => {
        const existing = byId.get(canonicalId);
        if (existing) {
            existing.topSection = removePromotionDuplicatesFromTopSectionSurface(topSection, existing.promotion);
            existing.order = { ...existing.order, topSection: order };
            if (!existing.promotion) {
                existing.promotion = createPromotionFromTopSection(canonicalId, topSection);
            }
            return;
        }
        const promotion = createPromotionFromTopSection(canonicalId, topSection);
        items.push({
            id: canonicalId,
            promotion,
            topSection: removePromotionDuplicatesFromTopSectionSurface(topSection, promotion),
            order: { promotions: Number.MAX_SAFE_INTEGER, topSection: order }
        });
    };
    setTopSection('champions-league-free-bet', {
        id: 'champions-league-free-bet',
        title: Verbiage.champions_league_free_bet,
        startDate: new Date('2026-02-11T00:00:00Z'),
        endDate: new Date('2026-05-30T23:59:59Z'),
        description: Verbiage.champions_league_free_bet_description,
        titleSingleLine: true,
        buttonText: Verbiage.bet_now,
        link: '/promotion-page/champions-league-free-bet/',
        backgroundImage: `${bannersBase}champions_league_free_bet/champions_league_free_bet.png`
    }, 3);
    setTopSection('welcome-deposit-bonus', {
        id: 'deposit-bonus',
        backgroundImage: `${bannersBase}deposit_bonus/deposit_bonus.png`,
        title: Verbiage.welcome_offer,
        description: Verbiage.welcome_offer_description,
        buttonText: Verbiage.claim_now,
        link: '/promotion-page/welcome-deposit-bonus/',
        imageStyles: 'transform: scale(0.85);',
        requiresDepositBonus: true
    }, 10);
    setTopSection('rakeboost', {
        id: 'rakeboost',
        backgroundImage: `${bannersBase}rakeboost/rakeboost.png`,
        title: Verbiage.rakeboost,
        description: Verbiage.rakeboost_description,
        buttonText: Verbiage.activate_now,
        link: '/vip/'
    }, 11);
    setTopSection('super-bowl-free-bet', {
        id: 'super-bowl-free-bet',
        title: Verbiage.super_bowl_free_bet,
        startDate: new Date('2026-02-03T00:00:00Z'),
        endDate: new Date('2026-02-09T00:00:00Z'),
        description: Verbiage.super_bowl_free_bet_description,
        buttonText: Verbiage.bet_now,
        link: '/promotion-page/super-bowl-free-bet/',
        backgroundImage: `${bannersBase}super_bowl_free_bet/super_bowl_free_bet.png`
    }, 12);
    setTopSection('super-scatter-series-daily-tournaments', {
        id: 'super-scatter-series-daily-tournaments',
        title: Verbiage.super_scatter_series_daily_tournaments,
        startDate: new Date('2025-10-31T00:00:00Z'),
        endDate: new Date('2025-11-13T23:59:59Z'),
        description: Verbiage.super_scatter_series_daily_tournaments_description,
        buttonText: Verbiage.bet_now,
        link: '/promotion-page/super-scatter-series-daily-tournaments/',
        backgroundImage: `${bannersBase}super_scatter_series_daily_tournaments/super_scatter_series_daily_tournaments.png`
    }, 13);
    setTopSection('super-scatter', {
        id: 'super-scatter',
        backgroundImage: `${bannersBase}super_scatter/super_scatter.png`,
        title: Verbiage.super_scatter,
        description: Verbiage.super_scatter_description,
        formatDescription: true,
        link: '/promotion-page/super-scatter',
        startDate: new Date('2025-08-01T00:00:00Z'),
        endDate: new Date('2025-08-18T23:59:59Z'),
        conditionalButton: {
            activeText: Verbiage.race_now,
            inactiveText: Verbiage.coming_soon,
            condition: 'afterStart'
        },
        buttonText: Verbiage.race_now
    }, 14);
    setTopSection('blaze-zombie', {
        id: 'blaze-zombie',
        backgroundImage: `${bannersBase}blaze_zombie/blaze_zombie-alt.png`,
        title: Verbiage.blaze_zombie,
        description: Verbiage.blaze_zombie_description,
        formatDescription: true,
        link: '/promotion-page/blaze-zombie',
        startDate: new Date('2025-08-29T00:00:00Z'),
        endDate: new Date('2025-09-12T23:59:59Z'),
        conditionalButton: {
            activeText: Verbiage.play_now,
            inactiveText: Verbiage.coming_soon,
            condition: 'afterStart'
        },
        buttonText: Verbiage.play_now,
        customDescriptionWidth: '80%'
    }, 15);
    setTopSection('multiplier-madness', {
        id: 'multiplier-madness',
        backgroundImage: `${bannersBase}multiplier_madness/multiplier_madness.png`,
        title: Verbiage.multiplier_madness,
        description: Verbiage.claim_your_slice,
        buttonText: Verbiage.claim_now,
        link: '/promotion-page/multiplier-madness',
        rel: FeatureSet.Preview
    }, 16);
    setTopSection('referral', {
        id: 'referral-dashboard',
        backgroundImage: `${bannersBase}referral-dashboard/referral-dashboard-banner-mobile.jpg`,
        title: Verbiage.refer_and_earn_banner_title,
        description: Verbiage.refer_and_earn_banner_description_mobile,
        multiLineDescription: true,
        buttonText: Verbiage.refer_now,
        conditionalLink: {
            loggedInLink: '/referral-dashboard/',
            loggedOutLink: '/referral/'
        },
        link: '/referral/',
        customDescriptionWidth: '65%'
    }, 7);
    setTopSection('sports', {
        id: 'sports',
        backgroundImage: `${bannersBase}sports/sports.png`,
        title: Verbiage.sports,
        description: Verbiage.sports_description,
        buttonText: Verbiage.play_now,
        link: '/sports/',
        imageStyles: 'transform: scale(0.85);',
        rel: FeatureSet.Preview,
        customDescriptionWidth: '60%'
    }, 17);
    setTopSection('flush-races', {
        id: 'flush-races',
        backgroundImage: `${bannersBase}races/races.png`,
        title: Verbiage.weekly_races,
        description: Verbiage.weekly_races_description,
        imageStyles: 'transform: scale(0.9);',
        link: '/promotion-page/race/flush-races/',
        startDate: new Date('2025-09-01T00:00:00Z'),
        conditionalButton: {
            activeText: Verbiage.race_now,
            inactiveText: Verbiage.starting_shortly,
            condition: 'afterStart'
        },
        buttonText: Verbiage.race_now
    }, 0);
    setTopSection('advent-calendar', {
        id: 'calendar',
        backgroundImage: `${bannersBase}advent_calendar/advent_calendar.png`,
        title: Verbiage.advent_calendar_banner_title,
        description: Verbiage.advent_calendar_banner_description,
        link: '/calendar/',
        startDate: new Date('2025-12-1T00:00:00Z'),
        endDate: new Date('2025-12-31T23:59:59Z'),
        buttonText: Verbiage.play_now,
        customTitleWidth: '70%',
        requireLogIn: true,
        conditionalButton: {
            activeText: Verbiage.play_now,
            inactiveText: Verbiage.coming_soon,
            condition: 'afterStart'
        }
    }, 18);
    setTopSection('canelo-vs-crawford', {
        id: 'canelo-vs-crawford',
        backgroundImage: `${bannersBase}canelo_vs_crawford/canelo_vs_crawford.png`,
        title: 'CANELO VS CRAWFORD',
        description: Verbiage.canelo_vs_crawford_description,
        formatDescription: true,
        link: '/promotion-page/canelo-vs-crawford',
        titleAllHighlighted: true,
        startDate: new Date('2025-09-13T01:00:00Z'),
        endDate: new Date('2025-09-14T01:00:00Z'),
        conditionalButton: {
            activeText: Verbiage.bet_now,
            inactiveText: Verbiage.coming_soon,
            condition: 'afterStart'
        },
        buttonText: Verbiage.bet_now
    }, 19);
    setTopSection('sweet-bonanza', {
        id: 'sweet-bonanza',
        title: Verbiage.sweet_bonanza,
        startDate: new Date('2025-09-30T13:00:00Z'),
        endDate: new Date('2025-10-14T18:00:00Z'),
        description: Verbiage.daily_tournaments,
        buttonText: Verbiage.play_now,
        link: '/promotion-page/sweet-bonanza/',
        backgroundImage: `${bannersBase}sweet_bonanza/sweet_bonanza.png`
    }, 20);
    setTopSection('world-series-bad-beat-bailout', {
        id: 'world-series-bad-beat-bailout',
        title: Verbiage.world_series_bad_beat_bailout,
        startDate: new Date('2025-10-24T00:00:00Z'),
        endDate: new Date('2025-11-01T23:59:59Z'),
        description: Verbiage.world_series_bad_beat_bailout_description,
        buttonText: Verbiage.bet_now,
        link: '/promotion-page/world-series-bad-beat-bailout/',
        backgroundImage: `${bannersBase}world_series_bad_beat_bailout/world_series_bad_beat_bailout.png`,
        customDescriptionWidth: '85%'
    }, 21);
    setTopSection('mnf-bet-builder-bailout', {
        id: 'mnf-bet-builder-bailout',
        backgroundImage: `${bannersBase}mnf_bet_builder_bailout/mnf_bet_builder_bailout.png`,
        title: Verbiage.mnf_bet_builder_bailout,
        description: Verbiage.mnf_bet_builder_bailout_description,
        formatDescription: true,
        link: '/promotion-page/mnf-bet-builder-bailout',
        startDate: new Date('2025-10-22T00:00:00Z'),
        endDate: new Date('2026-02-08T23:59:59Z'),
        conditionalButton: {
            activeText: Verbiage.bet_now,
            inactiveText: Verbiage.coming_soon,
            condition: 'afterStart'
        },
        buttonText: Verbiage.bet_now
    }, 22);
    setTopSection('daily-slot-tournaments-and-weekly-wheel-drops', {
        id: 'daily-slot-tournaments-and-weekly-wheel-drops',
        title: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops,
        startDate: new Date('2025-10-28T00:00:00Z'),
        endDate: new Date('2025-11-24T23:59:59Z'),
        description: Verbiage.daily_slot_tournaments_and_weekly_wheel_drops_description,
        buttonText: Verbiage.bet_now,
        link: '/promotion-page/daily-slot-tournaments-and-weekly-wheel-drops/',
        backgroundImage: `${bannersBase}daily_slot_tournaments_and_weekly_wheel_drops/daily_slot_tournaments_and_weekly_wheel_drops.png`
    }, 2);
    setTopSection('daily-wins-slots', {
        id: 'daily-wins-slots',
        title: Verbiage.daily_wins_slots,
        startDate: new Date('2026-01-04T16:00:00Z'),
        endDate: new Date('2026-02-01T15:59:59Z'),
        description: Verbiage.daily_wins_slots_description,
        buttonText: Verbiage.play_now,
        link: '/promotion-page/daily-wins-slots/',
        backgroundImage: `${bannersBase}daily_wins_slots/daily_wins_slots.png`,
        customDescriptionWidth: '100%'
    }, 23);
    setTopSection('daily-wins-slots-11', {
        id: 'daily-wins-slots-11',
        title: Verbiage.daily_wins_slots,
        startDate: new Date('2026-02-02T00:00:00Z'),
        endDate: new Date('2026-03-01T23:59:59Z'),
        description: Verbiage.daily_wins_slots_description,
        buttonText: Verbiage.play_now,
        link: '/promotion-page/daily-wins-slots-11/',
        backgroundImage: `${bannersBase}daily_wins_slots/daily_wins_slots.png`,
        customDescriptionWidth: '100%'
    }, 24);
    setTopSection('super-bowl-free-bet-duplicate', {
        id: 'super-bowl-free-bet',
        title: Verbiage.super_bowl_free_bet,
        startDate: new Date('2026-02-03T00:00:00Z'),
        endDate: new Date('2026-02-09T00:00:00Z'),
        description: Verbiage.super_bowl_free_bet_description,
        buttonText: Verbiage.bet_now,
        link: '/promotion-page/super-bowl-free-bet/',
        backgroundImage: `${bannersBase}super_bowl_free_bet/super_bowl_free_bet.png`
    }, 25);
    setTopSection('daily-bonus', {
        id: 'daily-bonus',
        title: Verbiage.reward_promo_daily_bonus_title,
        description: Verbiage.reward_promo_daily_bonus_description,
        buttonText: Verbiage.claim_now,
        link: '/vip/',
        conditionalLink: {
            loggedInLink: '/vip-dashboard/',
            loggedOutLink: '/vip/'
        }
    }, 6);
    setTopSection('weekly-bonus', {
        id: 'weekly-bonus',
        title: Verbiage.reward_promo_weekly_bonus_title,
        description: Verbiage.reward_promo_weekly_bonus_description,
        buttonText: Verbiage.claim_now,
        link: '/vip/',
        conditionalLink: {
            loggedInLink: '/vip-dashboard/',
            loggedOutLink: '/vip/'
        }
    }, 8);
    setTopSection('monthly-bonus', {
        id: 'monthly-bonus',
        title: Verbiage.reward_promo_monthly_bonus_title,
        description: Verbiage.reward_promo_monthly_bonus_description,
        buttonText: Verbiage.claim_now,
        link: '/vip/',
        conditionalLink: {
            loggedInLink: '/vip-dashboard/',
            loggedOutLink: '/vip/'
        }
    }, 9);
    setTopSection('rakeback', {
        id: 'rakeback',
        title: Verbiage.reward_promo_rakeback_title,
        description: Verbiage.reward_promo_rakeback_description,
        buttonText: Verbiage.claim_now,
        link: '/vip/',
        conditionalLink: {
            loggedInLink: '/vip-dashboard/',
            loggedOutLink: '/vip/'
        }
    }, 5);
    setTopSection('level-up', {
        id: 'level-up',
        title: Verbiage.reward_promo_level_up_bonus_title,
        description: Verbiage.reward_promo_level_up_bonus_description,
        buttonText: Verbiage.claim_now,
        link: '/vip/',
        conditionalLink: {
            loggedInLink: '/vip-dashboard/',
            loggedOutLink: '/vip/'
        }
    }, 4);
    setTopSection('jelly-express-daily-tournaments', {
        id: 'jelly-express-daily-tournaments',
        title: Verbiage.jelly_express_daily_tournaments,
        startDate: new Date('2026-04-06T12:00:00.000Z'),
        endDate: new Date('2026-05-03T16:59:59.999Z'),
        description: null,
        showTimezoneSuffixInFallback: false,
        buttonText: Verbiage.play_now,
        link: '/promotion-page/jelly-express-daily-tournaments/',
        backgroundImage: cfgToThemeCdnPath('/promotions/jelly_express_daily_tournaments/jelly_express_daily_tournaments.png'),
        multiLineDescription: true,
        customDescriptionWidth: '100%'
    }, 1);
    return items;
};
